<script>
    import { onMount } from 'svelte';
    import Card from './components/Card.svelte';
    let portfolioItems = [];
    let error = '';

    onMount(async () => {
        try {
            const res = await fetch('portfolio/manifest.json');
            if (!res.ok) throw new Error('Failed to load manifest');
            const manifest = await res.json();
            // Fetch info.json for each item in manifest
            const items = await Promise.all(
                manifest.map(async (item) => {
                    const infoRes = await fetch(item.info);
                    if (!infoRes.ok) throw new Error('Failed to load ' + item.info);
                    const info = await infoRes.json();
                    // Extract directory from info path (e.g. portfolio/one/info.json -> portfolio/one)
                    const directory = item.info.split('/').slice(0, -1).join('/');
                    return { directory, info };
                })
            );
            portfolioItems = items;
        } catch (e) {
            error = e.message;
        }
    });
</script>

<div class="front-page">
  {#if !error}
    <div class="card-list">
      {#each portfolioItems as item}
        <Card directory={item.directory} info={item.info} />
      {/each}
    </div>
  {/if}
</div>

<style>
.front-page {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
}
</style>
